/** Synthesised camera-shutter click (no audio asset). Browsers only allow playback after a user gesture. */
let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (ctx) return ctx;
  const Ctor = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  ctx = new Ctor();
  return ctx;
}

/** Call from a real user gesture so later clicks can play. */
export function primeShutterSound() {
  const c = getCtx();
  if (c && c.state === 'suspended') c.resume().catch(() => undefined);
}

function burst(c: AudioContext, at: number, dur: number, freq: number, gain: number) {
  const len = Math.floor(c.sampleRate * dur);
  const buf = c.createBuffer(1, len, c.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < len; i += 1) data[i] = (Math.random() * 2 - 1) * (1 - i / len) ** 3;
  const src = c.createBufferSource();
  src.buffer = buf;
  const bp = c.createBiquadFilter();
  bp.type = 'bandpass';
  bp.frequency.value = freq;
  bp.Q.value = 0.9;
  const g = c.createGain();
  g.gain.value = gain;
  src.connect(bp).connect(g).connect(c.destination);
  src.start(at);
}

export function playShutterSound() {
  const c = getCtx();
  if (!c || c.state !== 'running') return;
  const t = c.currentTime;
  burst(c, t, 0.035, 3200, 0.22);
  burst(c, t + 0.09, 0.05, 1800, 0.16);
}